module.exports = __webpack_public_path__ + "static/posterImageMini-38d3f79e6ffec1d49f7403550ce16237.jpg";